import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const items = [
  {
    titleKey: 'explore.1.title',
    icon: 'ri-grid-line',
    slug: 'usfans-spreadsheet-guide',
    image:
      'https://readdy.ai/api/search-image?query=A%20close%20up%20of%20a%20well%20organized%20digital%20spreadsheet%20on%20a%20laptop%20screen%20with%20colorful%20category%20tabs%2C%20clean%20workspace%2C%20soft%20natural%20light%2C%20minimalist%20editorial%20style%2C%20no%20text%2C%20no%20watermark&width=600&height=400&seq=explore-spreadsheet-01&orientation=landscape',
  },
  {
    titleKey: 'explore.2.title',
    icon: 'ri-search-eye-line',
    slug: 'usfans-spreadsheet-products',
    image:
      'https://readdy.ai/api/search-image?query=A%20person%20comparing%20two%20product%20cards%20on%20a%20tablet%20with%20a%20magnifying%20glass%20nearby%2C%20bright%20modern%20desk%20scene%2C%20soft%20natural%20light%2C%20minimalist%20editorial%20style%2C%20no%20text%2C%20no%20watermark&width=600&height=400&seq=explore-research-02&orientation=landscape',
  },
  {
    titleKey: 'explore.3.title',
    icon: 'ri-store-line',
    slug: 'usfans-spreadsheet-sellers',
    image:
      'https://readdy.ai/api/search-image?query=A%20small%20boutique%20storefront%20with%20neatly%20displayed%20clothing%20and%20shoes%20in%20a%20warm%20inviting%20interior%2C%20soft%20natural%20light%2C%20minimalist%20editorial%20style%2C%20no%20text%2C%20no%20watermark&width=600&height=400&seq=explore-sellers-03&orientation=landscape',
  },
  {
    titleKey: 'explore.4.title',
    icon: 'ri-star-line',
    slug: 'usfans-spreadsheet-comparison',
    image:
      'https://readdy.ai/api/search-image?query=A%20flat%20lay%20of%20customer%20review%20cards%20with%20five%20stars%20and%20a%20notebook%20on%20a%20clean%20desk%2C%20soft%20natural%20light%2C%20minimalist%20editorial%20style%2C%20no%20text%2C%20no%20watermark&width=600&height=400&seq=explore-reviews-04&orientation=landscape',
  },
  {
    titleKey: 'explore.5.title',
    icon: 'ri-truck-line',
    slug: 'usfans-shipping-cost',
    image:
      'https://readdy.ai/api/search-image?query=A%20cardboard%20shipping%20box%20with%20packing%20tape%20next%20to%20a%20small%20delivery%20truck%20toy%20on%20a%20clean%20surface%2C%20soft%20natural%20light%2C%20minimalist%20editorial%20style%2C%20no%20text%2C%20no%20watermark&width=600&height=400&seq=explore-shipping-05&orientation=landscape',
  },
  {
    titleKey: 'explore.6.title',
    icon: 'ri-archive-line',
    slug: 'usfans-warehouse',
    image:
      'https://readdy.ai/api/search-image?query=A%20tidy%20warehouse%20with%20wooden%20shelves%20holding%20neatly%20stacked%20labeled%20boxes%2C%20soft%20warm%20light%2C%20minimalist%20editorial%20style%2C%20no%20text%2C%20no%20watermark&width=600&height=400&seq=explore-warehouse-06&orientation=landscape',
  },
  {
    titleKey: 'explore.7.title',
    icon: 'ri-coupon-3-line',
    slug: 'usfans-coupon',
    image:
      'https://readdy.ai/api/search-image?query=A%20hand%20holding%20paper%20discount%20tags%20with%20a%20shopping%20bag%20in%20the%20background%20on%20a%20clean%20surface%2C%20soft%20natural%20light%2C%20minimalist%20editorial%20style%2C%20no%20text%2C%20no%20watermark&width=600&height=400&seq=explore-coupons-07&orientation=landscape',
  },
  {
    titleKey: 'explore.8.title',
    icon: 'ri-shield-check-line',
    slug: 'is-usfans-legit',
    image:
      'https://readdy.ai/api/search-image?query=A%20concept%20of%20online%20safety%20with%20a%20shield%20icon%20and%20a%20smartphone%20showing%20a%20lock%20symbol%20on%20a%20clean%20desk%2C%20soft%20natural%20light%2C%20minimalist%20editorial%20style%2C%20no%20text%2C%20no%20watermark&width=600&height=400&seq=explore-safety-08&orientation=landscape',
  },
];

export default function ExploreHub() {
  const { t } = useTranslation();

  return (
    <section id="explore" className="w-full px-4 md:px-6 py-14 md:py-20">
      <div className="mx-auto max-w-7xl">
        <div className="text-center max-w-2xl mx-auto">
          <h2 className="text-2xl md:text-4xl font-heading font-semibold text-foreground-950">{t('explore.title')}</h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base">{t('explore.subtitle')}</p>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {items.map((item) => (
            <Link
              key={item.slug}
              to={`/guides/${item.slug}`}
              className="group block rounded-lg overflow-hidden border border-background-200 bg-background-50 hover:border-primary-300 transition-colors"
            >
              <div className="relative w-full h-36 md:h-40 overflow-hidden">
                <img
                  src={item.image}
                  alt={`${t(item.titleKey)} — USFans Spreadsheet`}
                  title={`${t(item.titleKey)} — USFans Spreadsheet`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <span className="absolute left-3 bottom-3 w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/95 text-primary-600 shadow-sm">
                  <i className={`${item.icon} text-lg`} />
                </span>
              </div>
              <div className="px-4 py-3.5 flex items-center justify-between gap-2">
                <span className="text-sm font-semibold text-foreground-900 whitespace-nowrap">{t(item.titleKey)}</span>
                <span className="w-6 h-6 flex items-center justify-center shrink-0 text-primary-600 group-hover:translate-x-0.5 transition-transform">
                  <i className="ri-arrow-right-up-line text-base" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}